import React from 'react';
import { faqs, faqImage } from '../mock';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../components/ui/accordion';
import Seo from '../components/Seo';

const FAQ = () => {
  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: (faqs || []).map(f => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a }
    }))
  };
  return (
    <main className="max-w-[1000px] mx-auto px-6 md:px-10 pt-16 pb-16">
      <Seo
        title="FAQ | Vial Rat Research Co. — Canadian Research Peptides"
        description="Answers to common questions about ordering, shipping, storage and research-use policies at Vial Rat Research Co."
        canonicalPath="/faq"
        jsonLd={faqLd}
      />
      <div className="font-mono-label text-[11px] text-[#ff2fa1] mb-4">LAB NOTES</div>
      <h1 className="font-serif-display text-white text-6xl md:text-7xl">FAQ</h1>

      <img src={faqImage} alt="Lab" className="mt-10 rounded-xl border border-white/10 w-full max-h-[420px] object-cover" />

      <div className="mt-12">
        <Accordion type="single" collapsible className="w-full divide-y divide-white/10 border-y border-white/10">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-none">
              <AccordionTrigger className="font-serif-display text-white text-xl md:text-2xl py-6 hover:text-[#ff2fa1] hover:no-underline text-left">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-neutral-300 text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>

      <div className="mt-16 p-6 border border-[#ff2fa1]/20 bg-[#ff2fa1]/5 rounded">
        <div className="font-mono-label text-[11px] text-[#ff2fa1]">FOR RESEARCH USE ONLY</div>
        <p className="text-sm text-neutral-400 mt-2">Products are intended for laboratory and research purposes only. Not for human or veterinary use, food, or household application.</p>
      </div>
    </main>
  );
};

export default FAQ;
